import { API } from './ApiClient';

export type MediaUrlNavigator = (mediaUrl: string) => void;

const navigateCurrentWindow: MediaUrlNavigator = (mediaUrl) => {
    window.location.assign(mediaUrl);
};

/**
 * Requests an authenticated media endpoint and lets the browser load the URL it returns.
 * @param {string} authenticatedEndpoint Endpoint that returns the media URL.
 * @param {MediaUrlNavigator} navigate Callback used to load the returned media URL.
 */
export async function requestMediaUrl(
    authenticatedEndpoint: string,
    navigate: MediaUrlNavigator = navigateCurrentWindow,
): Promise<void> {
    const { data: mediaUrl } = await API.get<string>(authenticatedEndpoint);
    navigate(mediaUrl);
}
